import React from 'react';
import { FaSearch, FaChartBar, FaUserMd, FaDatabase } from 'react-icons/fa';
import './Solution.css';

const Solution = () => {
  const solutionFeatures = [
    {
      icon: <FaSearch />,
      title: 'AI-Powered Wound Detection',
      description: 'Detect and measure wounds with precision'
    },
    {
      icon: <FaChartBar />,
      title: 'Progress Tracking',
      description: 'Monitor healing over time with detailed analytics'
    },
    {
      icon: <FaUserMd />,
      title: 'Remote Consultations',
      description: 'Share reports with doctors instantly'
    },
    {
      icon: <FaDatabase />,
      title: 'Secure Data Storage',
      description: 'Robust encryption and privacy protection for your health data'
    }
  ];
  
  return (
    <section id="solution" className="solution">
      <div className="container">
        <h2>Our Solution: HealAI</h2>
        <div className="solution-content">
          <div className="solution-image">
            <img src="/Picture6.png" alt="HealAI App" style={{ maxWidth: '55%', height: '50%' }} />
          </div>
          <div className="solution-text">
            <h3>What is HealAI?</h3>
            <p>
              HealAI is our flagship mobile application designed specifically for diabetic foot ulcer
              management. It allows patients to monitor their wounds at home while providing healthcare
              professionals with accurate data for remote assessment.
            </p>
            
            <div className="solution-features">
              {solutionFeatures.map((feature, index) => (
                <div key={index} className="solution-feature">
                  {feature.icon}
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
